import React, { Fragment, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { H5, LI, UL } from '../../AbstractElements'
import SidebarSubMenu from './SidebarSubMenu'
import { RootState, AppDispatch } from '../../ReduxToolkit/Store';
import { Pinned } from '../../Utils/Constants';
import { SidebarMenuItem } from '../../Types/Layout.type';
import { fetchMenu } from '../../ReduxToolkit/Reducers/Layout/LayoutReducer';

export default function SidebarNav() {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [activeMenu, setActiveMenu] = useState<string[]>([]);
    const { pinedMenu, menuList, menuLoading, menuError } = useSelector((state: RootState) => state.layout);
    const [currentEmail, setCurrentEmail] = useState<string | null>(localStorage.getItem("email"));
    
    useEffect(() => {
        const email = localStorage.getItem("email");
        // Se l'email è cambiata o il menu è vuoto, ricarica il menu
        if (email !== currentEmail || (menuList.length === 0 && !menuLoading && email)) {
            setCurrentEmail(email);
            if (email) {
                dispatch(fetchMenu());
            }
        }
    }, [dispatch, menuList.length, menuLoading, currentEmail]);
    const shouldHideMenu = (mainMenu: SidebarMenuItem) => {
        return mainMenu?.items?.map((data) => data.title).every((titles) => pinedMenu.includes(titles || ""));
    }
    return (
        <UL className="sidebar-menu simple-list flex-column justify-content-between" id="simple-bar">
            <div className="simplebar-wrapper">
                <div className="simplebar-mask">
                    <div className="simplebar-offset">
                        <div className="simplebar-content-wrapper">
                            <div className="simplebar-content">
                                <LI className={`pin-title sidebar-main-title ${pinedMenu.length > 0 ? "show" : ""} `}>
                                    <div>
                                        <H5 className="sidebar-title f-w-700">{Pinned}</H5>
                                    </div>
                                </LI>
                                {menuLoading && <LI><div>Caricamento menu...</div></LI>}
                                {menuError && <LI><div>Errore: {menuError}</div></LI>}
                                {!menuLoading && !menuError && menuList &&
                                    menuList.map((mainMenu: SidebarMenuItem, index) => (
                                        <Fragment key={index}>
                                            <LI className={`sidebar-main-title ${shouldHideMenu(mainMenu) ? 'd-none' : ''}`}>
                                                <div>
                                                    <H5 className={`${mainMenu.lanClass ? mainMenu.lanClass : ''} f-w-700 sidebar-title`}>{t(`${mainMenu.title}`)}</H5>
                                                </div>
                                            </LI>
                                            <SidebarSubMenu menu={mainMenu.items} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={0} />
                                        </Fragment>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ps-0'>
               <small> Powerd: I-factory </small>
            </div>
        </UL>
    )
}
